import { render, staticRenderFns } from "./signRecord.vue?vue&type=template&id=7212ee52&scoped=true"
import script from "./signRecord.vue?vue&type=script&lang=js"
export * from "./signRecord.vue?vue&type=script&lang=js"
import style0 from "./signRecord.vue?vue&type=style&index=0&id=7212ee52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7212ee52",
  null
  
)

export default component.exports